module.exports = __webpack_public_path__ + "img/chat.1213e7f5.webp";